import { render, staticRenderFns } from "./SettingsEmails.vue?vue&type=template&id=6ece357d"
import script from "./SettingsEmails.vue?vue&type=script&lang=js"
export * from "./SettingsEmails.vue?vue&type=script&lang=js"
import style0 from "./SettingsEmails.vue?vue&type=style&index=0&id=6ece357d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports